import styled from 'styled-components';
import { Link } from '@terrainvest/react-components';

export const StyledLink = styled(Link)`
    ${Link.Styles.StyledText} {
        margin: 0;
        margin-left: 5px;
    }
`;
